SP.optic = {
  ACC: typeof ACCMOB !== 'undefined' ? ACCMOB : ACC,
  addOpticProduct: function (data, price, callback) {
    $.post(
      this.ACC.config.encodedContextPath + '/cart/addOpticToCart',
      data,
      function (response) {
        callback(response)
        if (response.opticsEventData) {
          let itemPrice = price / (response.opticsEventData.leftEyeNewQuantity + response.opticsEventData.rightEyeNewQuantity)
          if (
            response.opticsEventData.leftEyeCode &&
            response.opticsEventData.leftEyeOldQuantity !=
              response.opticsEventData.leftEyeNewQuantity
          ) {
            for (i = 0; i < response.entries.length; i++) {
              if (
                response.entries[i].productCode ==
                response.opticsEventData.leftEyeCode
              ) {
                let dyEventData = {
                  productCode: response.opticsEventData.leftEyeCode,
                  price: itemPrice
                }
                SP.dy.updateCart(dyEventData,
                    response.opticsEventData.leftEyeOldQuantity,
                    response.opticsEventData.leftEyeNewQuantity)

                response.entries[i].price =  response.entries[i].baseDiscountPrice ?  response.entries[i].baseDiscountPrice :  response.entries[i].basePrice
                SP.gtm.updateCart(
                  response.entries[i],
                  response.opticsEventData.leftEyeOldQuantity,
                  response.opticsEventData.leftEyeNewQuantity
                )
                break
              }
            }
          }
          if (
            response.opticsEventData.rightEyeCode &&
            response.opticsEventData.rightEyeOldQuantity !=
              response.opticsEventData.rightEyeNewQuantity
          ) {
            for (j = 0; j < response.entries.length; j++) {
              if (
                response.entries[j].productCode ==
                response.opticsEventData.rightEyeCode
              ) {
                let dyEventData = {
                  productCode: response.opticsEventData.rightEyeCode,
                  price: itemPrice
                }
                SP.dy.updateCart(dyEventData,
                    response.opticsEventData.rightEyeOldQuantity,
                    response.opticsEventData.rightEyeNewQuantity)

                response.entries[j].price =  response.entries[j].baseDiscountPrice ?  response.entries[j].baseDiscountPrice :  response.entries[j].basePrice
                SP.gtm.updateCart(
                  response.entries[j],
                  response.opticsEventData.rightEyeOldQuantity,
                  response.opticsEventData.rightEyeNewQuantity
                )
                break
              }
            }
          }
        }
      }
    )
  },
  getOpticPrice: function (code, count, callback) {
    //TODO: set real endpoint

    $.post(
      this.ACC.config.encodedContextPath + '/cart/getOpticPrice',
      {
        code: code,
        count: count,
      },
      function (response) {
        callback(response)
      }
    )
  },
}
